(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("cornerstoneWebImageLoader", [], factory);
	else if(typeof exports === 'object')
		exports["cornerstoneWebImageLoader"] = factory();
	else
		root["cornerstoneWebImageLoader"] = factory();
})(window, function() {
return 